/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsListSchedules } from "../../funcs/llmEvalsListSchedules.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListEvalSchedulesRequest$inboundSchema,
};

export const tool$llmEvalsListSchedules: ToolDefinition<typeof args> = {
  name: "llm-evals-list-schedules",
  description: `List eval schedules

Returns eval schedules visible to the authenticated team context.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsListSchedules(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
